import { render, staticRenderFns } from "./ProductReserveTable.vue?vue&type=template&id=12b3c974&scoped=true"
import script from "./ProductReserveTable.vue?vue&type=script&lang=js"
export * from "./ProductReserveTable.vue?vue&type=script&lang=js"
import style0 from "./ProductReserveTable.vue?vue&type=style&index=0&id=12b3c974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b3c974",
  null
  
)

export default component.exports